import { useState } from "react";

const MessageBox = (props) => {
  const [selectedFilValueOnId, setSelectedFilValueOnId] = useState([]);
  const { isOpen, text, functions, close } = props;
  var displaystyle = isOpen ? { display: "block" } : { display: "none" };
  var _class = isOpen ? "show" : "";
  const _msg =
    text.msg !== undefined
      ? text.msg.split("\n").reduce((prev, cur) => [...prev, cur, <br />], [])
      : "";

  return isOpen ? (
    <div
      className={"modal in " + _class}
      id="MsgModalCenter"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="MsgModalCenterTitle"
      aria-hidden="true"
      style={({ opacity: "1" }, displaystyle)}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="MsgModalLongTitle">
              {text.title}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                close();
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <p className="msgBodyFont">{_msg}</p>
          </div>
          <div className="modal-footer py-3">
            <div className="form-group  my-0">
              {isOpen &&
                functions &&
                functions.map((value, index) => {
                  return (
                    <button
                      key={index}
                      type="button"
                      className="btn btn-primary ml-2"
                      onClick={() => {
                        value.func(text.anlageID, text.haschildren);
                        setSelectedFilValueOnId([]);
                      }}
                    >
                      {value.title}
                    </button>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
export default MessageBox;
